import { type UpdateCustomerProfilePayload } from '@/modules/api';

import { type CreateProfileFormValues } from '../schema/createProfileSchema';

// Assembles the customer-profile PATCH for the create-profile step. Mirrors
// Sparta's createCustomerProfile: height as total inches (feet * 12 + inches),
// weight in lbs, single-char gender, ethnicity slug.
export const buildUpdateProfilePayload = (
  customerProfileUri: string,
  values: CreateProfileFormValues
): UpdateCustomerProfilePayload => {
  return {
    customerProfileUri,
    customerProfile: {
      height: Number(values.feet) * 12 + Number(values.inches),
      weight: Number(values.weight),
      gender: values.gender,
      ethnicity: values.ethnicity,
    },
  };
};
